import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { ArrowLeft, MapPin, Settings as SettingsIcon } from 'lucide-react';

const CompanyCarHub = ({ user }) => {
  const navigate = useNavigate();

  // Encon brand colors
  const enconOrange = '#ee7203';
  const enconBlack = '#1d1d1b';
  const enconGrey = '#9d9d9c';
  const enconLightGrey = '#ededed';

  const modules = [
    {
      id: 'mileage',
      title: 'Mileage Tracker',
      description: 'Track business trips, mileage, and generate reports',
      icon: MapPin,
      route: '/mileage-tracker',
      available: user?.role === 'super_admin' || user?.mileage_tracker_access || false,
      color: enconOrange,
    },
    {
      id: 'admin',
      title: 'Admin',
      description: 'Vehicle administration and management',
      icon: SettingsIcon,
      route: '/company-car-admin',
      available: false,
      color: enconGrey,
    },
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: enconLightGrey }}>
      {/* Header */}
      <div className="bg-white shadow-md border-b" style={{ borderColor: enconGrey }}>
        <div className="px-4 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={() => navigate('/hub')}
                className="gap-2"
                style={{ color: enconOrange }}
              >
                <ArrowLeft className="w-5 h-5" />
                Back to Hub
              </Button>
              <div>
                <h1 className="text-4xl font-bold" style={{ color: enconBlack }}>
                  Company Car
                </h1>
                <p className="text-sm mt-2" style={{ color: enconGrey }}>
                  Manage your company vehicle and mileage
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-4 lg:px-8 py-12">
        <div className="max-w-7xl mx-auto">
          {/* Modules Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {modules.map((module) => {
              const Icon = module.icon;
              return (
                <Card
                  key={module.id}
                  className={`transition-all duration-200 border-2 ${
                    module.available 
                      ? 'hover:shadow-xl cursor-pointer hover:-translate-y-1' 
                      : 'opacity-60 cursor-not-allowed'
                  }`}
                  style={{ 
                    borderColor: module.available ? module.color : enconGrey,
                  }}
                  onClick={() => module.available && navigate(module.route)}
                >
                  <CardHeader>
                    <div 
                      className="w-16 h-16 rounded-lg flex items-center justify-center mb-4"
                      style={{ backgroundColor: module.color, opacity: module.available ? 1 : 0.5 }}
                    >
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <CardTitle className="text-2xl" style={{ color: enconBlack }}>
                      {module.title}
                    </CardTitle>
                    <CardDescription className="text-base" style={{ color: enconGrey }}>
                      {module.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    {module.available ? (
                      <Button 
                        className="w-full font-medium"
                        style={{ backgroundColor: module.color, color: 'white' }}
                      >
                        Open Module →
                      </Button>
                    ) : (
                      <div className="text-center py-2 text-sm" style={{ color: enconGrey }}>
                        Coming Soon
                      </div>
                    )}
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyCarHub;
